module.exports = __webpack_public_path__ + "static/media/faq-item-8.287e3099.png";